"use client"
import React from "react";
import "./Opportunity.scss";
import {toggleSendCVModal} from "@/helpers/toggleModals";
const Opportunity = () => {
  return (
    <section className="opportunity">
      <div className="careers__container opportunity__container">
        <h3 className="opportunity__title">
          Haven't found a career opportunity? Let us know about you!
        </h3>
        <div className="opportunity__send">
          <p className="opportunity__text">
            Send us your CV and we will contact you as soon as we have a
            suitable position.
          </p>
          <button onClick={toggleSendCVModal} className="button">Send CV</button>
        </div>
      </div>
    </section>
  );
};

export default Opportunity;
